/* eslint-disable max-len */

export const labels = {
  20: 'Silové kabely do 1 kV',
  20001: 'Silové kabely do 1 kV - sdělovací kabely nechráněné',
  20002: 'Silové kabely do 1 kV - sdělovací kabely chráněné',
  2: 'Silové kabely do 10 kV',
  2001: 'Silové kabely do 10 kV - sdělovací kabely nechráněné',
  2002: 'Silové kabely do 10 kV - sdělovací kabely chráněné',
  3: 'Silové kabely do 35 kV',
  3001: 'Silové kabely do 35 kV - sdělovací kabely nechráněné',
  3002: 'Silové kabely do 35 kV - sdělovací kabely chráněné',
  4: 'Silové kabely do 220 kV',
  5: 'Sdělovací kabely',
  51: 'Sdělovací kabely nechráněné',
  52: 'Sdělovací kabely chráněné',
  6: 'Plynovodní potrubí do 0,005 Mpa',
  7: 'Plynovodní potrubí do 0,3 MPa',
  8: 'Vodovodní sítě a přípojky',
  81: 'Vodovodní sítě a přípojky - silové kabely nechráněné',
  82: 'Vodovodní sítě a přípojky - silové kabely chráněné',
  9: 'Tepelné sítě',
  901: 'Tepelné sítě - sdělovací kabely nechráněné',
  902: 'Tepelné sítě - sdělovací kabely chráněné',
  10: 'Kabelovody',
  11: 'Stokové sítě a kanalizační přípojky',
  12: 'Potrubní pošta',
  13: 'Kolektor',
  14: 'Koleje tramvajové dráhy'
}

export const items = {
  MT: [{ l: 'Silové kabely', i: [20, 2, 3, 4] }, 5, {l: 'Plynovodní potrubí', i: [6, 7]}, 8, 9, 10, 11, 12, 13, 14],
  M: [ 20, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14 ],
  A: [ 20, 2, 3, 4, 51, 52, 6, 7, 81, 82, 9, 10, 11, 12, 13, 14 ],
  B: [ 20, 2, 3, 4, 5, 6, 7, 81, 82, 9, 10, 11, 12, 13, 14 ],
  C: [ 20, 2, 3, 4, 51, 52, 6, 7, 8, 9, 10, 11, 12, 13, 14 ],
  D: [ 20001, 20002, 2001, 2002, 3001, 3002, 4, 5, 6, 7, 8, 901, 902, 10, 11, 12, 13, 14 ],
  E: [ 20001, 20002, 2001, 2002, 3001, 3002, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14 ]
}

export const tree = {
  20: 'A',
  2: 'A',
  3: 'A',
  4: 'M',
  5: 'D',
  6: 'M',
  7: 'M',
  8: 'E',
  9: 'C',
  10: 'M',
  11: 'M',
  12: 'M',
  13: 'M',
  14: 'M'
}

export const notes1 = {
  1: 'Vzdálenosti se měří mezi vnějšími povrchy kabelů, potrubí, stok, ochranné konstrukce nebo kolejnice bližší k vedení.',
  2: 'Pro nejmenší vzdálenosti mezi povrchy vysokotlakého plynovodního potrubí a ostatních sítí technického vybavení platí ČSN 38 6410.',
  3: 'Nechráněné.',
  4: 'V technickém kanálu nebo betonových chráničkách. Podle ustanovení ČSN 33 3300.',
  5: 'Až k vnějšímu líci stavební konstrukce.',
  6: 'Vzdálenost musí být po dohodě s výrobcem kabelu kontrolována výpočtem.',
  7: 'Sdělovací kabel v betonové chráničce zalité asfaltem, délka přesahu chráničky 1500 mm na každé straně od místaukončení souběhu. Je-li vzdálenost obou souběžných kabelů větší než 1500 mm, ochranné opatření odpadá.',
  8: 'Nebezpečné vlivy vedení vn, vvn a zvn musí být kontrolovány výpočtem podle ČSN 33 2160.',
  9: 'Protikorozní opatření nutno projednat se správcem plynovodu individuálně.',
  10: 'Spojovací kabely se kladou navzájem volně vedle sebe. Spojovací kabely a kabely DR se kladou navzájem ve vzdálenosti 70 mm.',
  11: 'Platí pro souběh tepelně nechráněných kabelů a vodních tepelných vedení. Při tepelně chráněných kabelech možno snížit na 300 mm. Dlouhé souběhy nutno kontrolovat výpočtem. Pro souběh parních tepelných vedení s tepelně nechráněnými kabely platí vzdálenost 2000 mm; při kabelu tepelně chráněném, v souběhu délky do 200 mm, možno snížit na 800 mm.',
  12: 'Při souběhu obou vedení lze vzdálenost snížit po dohodě se správci vedení na 400 mm.',
  13: 'Pro přešetření teplotních poměrů možno snížit až na 600 mm.',
  14: 'Nejsou-li stoky pode dnem kolektoru (podle článku 82 ČSN 73 6701 : 1983).',
  15: 'Mezi trakčními kabely různé polarity musí být vzdálenost nejméně 0,15 m.'
}

export const notes2 = {
  1: 'Vzdálenosti se měří mezi vnějšími povrchy kabelů, potrubí, stok, ochranné konstrukce, nebo kolejnice bližší vedení.',
  2: 'Plynovody provedené z IPE: viz technická pravidla COPZ G 702 01 - Plynovody a přípojky z polyethylenu. Pro nejmenší vzdálenosti mezi povrchy vysokotlakého plynovodního potrubí a ostatních sítí technického vybavení platí ČSN 38 6410. Pro vysokotlakou přípojku do regulační stanice se vzdálenosti podle ČSN 38 6410 tabulka 5 zkracují v položkách2, 3, 4 a 7 na polovinu.',
  3: 'Vzdálenosti platí pro vodní tepelná vedení. Pro parní tepelná je nutné vzdálenost stanovit tak, aby byly splněny podmínky čl.4.7.3. Pro křížení parního tepelného vedení se sdělovacími kabely se vzdálenost zvětšuje u chráněných kabelů na 250 mm.',
  4: 'Nechráněné.',
  5: 'V technickém kanálu nebo betonových chráničkách podle ustanovení ČSN 33 3300.',
  6: 'Kabel v chráničce přesahující plynovod na každou stranu 1000 mm. Pro kabel bez ochranného krytu se zvětšují vzdálenosti takto: při křížení ntl plynovodu s kabely do 35kV na 400 mm, při křížení stl plynovodu s kabely do 10kV na 1000 mm, s kabely do 353kV na 1500 mm.',
  7: 'Při uložení v chráničce možno přiměřeně snížit.',
  8: 'Až k vnějšímu líci stavební konstrukce.',
  9: 'Kabel nižšího napětí uložen v chráničce.',
  10: 'Kabely VVN uloženy v chráničce přesahující místo křížení na každou stranu o 2000 mm.',
  11: 'Sdělovací kabely uloženy v betonových žlabech apod., zalitých asfaltem v délce přesahující místo křížení na obě strany minimálně 2000 mm.',
  12: 'Vlivy kabelu VVN na sdělovací vedení kontrolovat výpočtem dle ČSN 33 2160.',
  13: 'Kabely VVN uloženy pod plynovodem v chráničkách zasypaných vrstvou písku tloušťky nejméně 300 mm a pokrytou 2 vrstvami ochranných krycích desek, v délce přesahující místo křížení nejméně 1000 mm u ntl plynovodu a 2000 mm u stl plynovodu. Se správcem plynovodu projednat individuální protikorozní opatření.',
  14: 'Spojové kabely navzájem ve vzdálenosti 300 mm, spojové kabely a kabely DR ve vzdálenosti 700 mm.',
  15: 'Je-li tepelné vedení v ochranném tělese se vzduchovou mezerou nebo jde-li o kabelovod či kolektor, nutno plynovod opatřit chráničkou přesahující druhé vedení na každou stranu o 1000 mm.',
  16: 'Křižuje-li plynovod stokové potrubí v menší vzdálenosti než 500 mm minimálně však 150 mm, opatří se plynovod trojnásobnou izolací přesahující stokové potrubí na každou stranu o 1000 mm a vyhovující jiskrové zkoušce pro zkušební napětí 25 kV.',
  17: 'Je-li vodovodní potrubí uloženo pod tepelným vedením, kabelovodem či kolektorem, musí být opatřeno ochranným krytem. Jinak nejmenší vzdálenost vodovodního potrubí musí být 350 mm.'
}

export const data = {
  2020: [20, 20, 0.05, [15], 0.05, []],
  202: [20, 2, 0.15, [], 0.15, []],
  203: [20, 3, 0.2, [], 0.2, []],
  204: [20, 4, 0.2, [], 0.2, []],
  2051: [20, 51, 0.3, [3], 0.3, [4]],
  2052: [20, 52, 0.1, [4], 0.3, [5]],
  206: [20, 6, 0.4, [], 0.1, [6]],
  207: [20, 7, 0.6, [], 0.1, [6]],
  2081: [20, 81, 0.4, [], 0.4, [4]],
  2082: [20, 82, 0.4, [], 0.2, [5]],
  209: [20, 9, 0.3, [], 0.3, [7]],
  2010: [20, 10, 0.1, [], 0.1, []],
  2011: [20, 11, 0.5, [], 0.3, []],
  2012: [20, 12, 0.5, [], 0.3, []],
  2013: [20, 13, -1, [5], -1, [8]],
  2014: [20, 14, 1, [], 1, []],
  220: [2, 20, 0.15, [], 0.15, []],
  22: [2, 2, 0.15, [], 0.15, []],
  23: [2, 3, 0.2, [], 0.2, []],
  24: [2, 4, 0.2, [], 0.2, []],
  251: [2, 51, 0.8, [3], 0.8, [4]],
  252: [2, 52, 0.3, [4], 0.3, [5]],
  26: [2, 6, 0.4, [], 0.1, [6]],
  27: [2, 7, 0.6, [], 0.2, [6]],
  281: [2, 81, 0.4, [], 0.4, [4]],
  282: [2, 82, 0.4, [], 0.2, [5]],
  29: [2, 9, 0.7, [], 0.5, [7]],
  210: [2, 10, 0.3, [], 0.3, []],
  211: [2, 11, 0.5, [], 0.3, []],
  212: [2, 12, 0.5, [], 0.3, []],
  213: [2, 13, -1, [5], -1, [8]],
  214: [2, 14, 1, [], 1, []],
  320: [3, 20, 0.2, [], 0.2, []],
  32: [3, 2, 0.2, [], 0.2, []],
  33: [3, 3, 0.2, [], 0.2, []],
  34: [3, 4, 0.2, [], 0.25, [9]],
  351: [3, 51, 0.8, [3], 0.8, [4]],
  352: [3, 52, 0.3, [4], 0.3, [5]],
  36: [3, 6, 0.4, [], 0.1, [6]],
  37: [3, 7, 0.6, [], 0.2, [6]],
  381: [3, 81, 0.4, [], 0.4, [4]],
  382: [3, 82, 0.4, [], 0.2, [5]],
  39: [3, 9, 1, [], 0.5, [7]],
  310: [3, 10, 0.3, [], 0.3, []],
  311: [3, 11, 0.5, [], 0.5, []],
  312: [3, 12, 0.5, [], 0.3, []],
  313: [3, 13, -1, [5], -1, [8]],
  314: [3, 14, 1, [], 1, []],
  420: [4, 20, 0.2, [], 0.2, []],
  42: [4, 2, 0.2, [], 0.2, []],
  43: [4, 3, 0.2, [], 0.25, [9]],
  44: [4, 4, 0.5, [6], 0.25, []],
  45: [4, 5, 0.8, [7, 8], 0.8, [10, 11, 12]],
  46: [4, 6, 0.4, [], 0.3, [13]],
  47: [4, 7, 0.6, [], 0.7, [13]],
  48: [4, 8, 0.4, [], 0.4, []],
  49: [4, 9, 2, [6], 1, []],
  410: [4, 10, 0.5, [], 0.3, []],
  411: [4, 11, 1, [], 0.5, []],
  412: [4, 12, 0.5, [8], 0.3, [10, 12]],
  413: [4, 13, -1, [5], -1, [8]],
  414: [4, 14, 1, [], 1.3, []],
  520001: [51, 20, 0.3, [3], 0.3, [4]],
  520002: [52, 20, 0.1, [4], 0.1, [5]],
  52001: [51, 2, 0.8, [3], 0.8, [4]],
  52002: [52, 2, 0.3, [4], 0.3, [5]],
  53001: [51, 3, 0.8, [3], 0.8, [4]],
  53002: [52, 3, 0.3, [4], 0.3, [5]],
  54: [51, 4, 0.8, [7, 8], 0.5, [10, 11, 12]],
  55: [51, 5, -1, [10], -1, [14]],
  56: [51, 6, 0.4, [], 0.1, []],
  57: [51, 7, 0.4, [], 0.1, []],
  58: [51, 8, 0.4, [], 0.2, []],
  5901: [51, 9, 0.8, [11], 0.5, [4]],
  5902: [51, 9, 0.8, [11], 0.15, [5]],
  510: [51, 10, 0.3, [], 0.1, []],
  511: [51, 11, 0.5, [], 0.2, []],
  512: [51, 12, 0.2, [], 0.2, []],
  513: [51, 13, 0.3, [], 0.1, []],
  514: [51, 14, 1, [], 1, [5]],
  620: [6, 20, 0.4, [], 0.1, [6]],
  62: [6, 2, 0.4, [], 0.1, [6]],
  63: [6, 3, 0.4, [], 0.1, [6]],
  64: [6, 4, 0.4, [], 0.3, [13]],
  65: [6, 5, 0.4, [], 0.1, []],
  66: [6, 6, 0.4, [], 0.1, []],
  67: [6, 7, 0.4, [], 0.1, []],
  68: [6, 8, 0.5, [12], 0.15, []],
  69: [6, 9, 0.5, [], 0.1, [15]],
  610: [6, 10, 0.4, [], 0.1, [15]],
  611: [6, 11, 1, [12], 0.5, [16]],
  612: [6, 12, 0.4, [], 0.1, []],
  613: [6, 13, 0.4, [], 0.1, [15]],
  614: [6, 14, 1.2, [], 1, []],
  720: [7, 20, 0.6, [], 0.1, [6]],
  72: [7, 2, 0.6, [], 0.2, [6]],
  73: [7, 3, 0.6, [], 0.2, [6]],
  74: [7, 4, 0.6, [9], 0.7, [13]],
  75: [7, 5, 0.4, [], 0.1, []],
  76: [7, 6, 0.4, [], 0.1, []],
  77: [7, 7, 0.4, [], 0.1, []],
  78: [7, 8, 0.5, [], 0.15, []],
  79: [7, 9, 0.5, [], 0.1, [15]],
  710: [7, 10, 1, [], 0.1, [15]],
  711: [7, 11, 1, [], 0.5, [16]],
  712: [7, 12, 0.4, [], 0.1, []],
  713: [7, 13, 1, [], 0.1, [15]],
  714: [7, 14, 1.2, [], 1, []],
  820001: [81, 20, 0.4, [], 0.4, [4]],
  820002: [82, 20, 0.4, [], 0.2, [5]],
  82001: [81, 2, 0.4, [], 0.4, [4]],
  82002: [82, 2, 0.4, [], 0.2, [5]],
  83001: [81, 3, 0.4, [], 0.4, [4]],
  83002: [82, 3, 0.4, [], 0.2, [5]],
  84: [81, 4, 0.4, [], 0.4, []],
  85: [81, 5, 0.4, [], 0.2, []],
  86: [81, 6, 0.5, [12], 0.15, []],
  87: [81, 7, 0.5, [], 0.15, []],
  88: [81, 8, 0.6, [], -1, []],
  89: [81, 9, 1, [12], 0.2, [17]],
  810: [81, 10, 0.6, [], 0.2, [17]],
  811: [81, 11, 0.6, [], 0.1, []],
  812: [81, 12, 0.5, [], 0.2, []],
  813: [81, 13, 0.6, [], 0.2, [17]],
  814: [81, 14, 1.2, [], 1.5, []],
  920: [9, 20, 0.3, [], 0.3, [7]],
  92: [9, 2, 0.7, [], 0.5, [7]],
  93: [9, 3, 1, [], 0.5, [7]],
  94: [9, 4, 2, [6], 1, []],
  95: [9, 51, 0.8, [11], 0.5, [4]],
  951: [9, 51, 0.8, [11], 0.5, [4]],
  952: [9, 52, 0.8, [11], 0.15, [5]],
  96: [9, 6, 0.5, [], 0.1, [15]],
  97: [9, 7, 0.5, [], 0.1, []],
  98: [9, 8, 1, [13], 0.2, [17]],
  99: [9, 9, -1, [], 0.2, []],
  910: [9, 10, 0.3, [], 0.15, []],
  911: [9, 11, 0.3, [], 0.1, []],
  912: [9, 12, 0.3, [], 0.2, []],
  913: [9, 13, 0.3, [], 0.2, []],
  914: [9, 14, 1.2, [], 1, []],
  1020: [10, 20, 0.1, [], 0.1, []],
  102: [10, 2, 0.3, [], 0.3, []],
  103: [10, 3, 0.3, [], 0.3, []],
  104: [10, 4, 0.5, [], 0.3, []],
  105: [10, 5, 0.3, [], 0.1, []],
  106: [10, 6, 0.4, [], 0.1, [15]],
  107: [10, 7, 1, [], 0.1, []],
  108: [10, 8, 0.6, [], 0.2, [17]],
  109: [10, 9, 0.3, [], 0.15, []],
  1010: [10, 10, -1, [], -1, []],
  1011: [10, 11, 0.3, [], 0.1, []],
  1012: [10, 12, 0.2, [], 0.2, []],
  1013: [10, 13, 0.3, [], 0.2, []],
  1014: [10, 14, 1.2, [], 1, []],
  1120: [11, 20, 0.5, [], 0.3, []],
  112: [11, 2, 0.5, [], 0.3, []],
  113: [11, 3, 0.5, [], 0.5, []],
  114: [11, 4, 1, [], 0.5, []],
  115: [11, 5, 0.5, [], 0.2, []],
  116: [11, 6, 1, [12], 0.5, [16]],
  117: [11, 7, 1, [], 0.5, []],
  118: [11, 8, 0.6, [], 0.1, []],
  119: [11, 9, 0.3, [], 0.1, []],
  1110: [11, 10, 0.3, [], 0.1, []],
  1111: [11, 11, -1, [], -1, []],
  1112: [11, 12, 0.3, [], 0.3, []],
  1113: [11, 13, 0.3, [14], 0.1, []],
  1114: [11, 14, 1.2, [], -1, []],
  1220: [12, 20, 0.5, [], 0.3, []],
  122: [12, 2, 0.5, [], 0.3, []],
  123: [12, 3, 0.5, [], 0.3, []],
  124: [12, 4, 0.5, [8], 0.3, [10, 12]],
  125: [12, 5, 0.2, [], 0.2, []],
  126: [12, 6, 0.4, [], 0.1, []],
  127: [12, 7, 0.4, [], 0.1, []],
  128: [12, 8, 0.5, [], 0.3, []],
  129: [12, 9, 0.3, [], 0.2, []],
  1210: [12, 10, 0.2, [], 0.2, []],
  1211: [12, 11, 0.3, [], 0.3, []],
  1212: [12, 12, -1, [], -1, []],
  1213: [12, 13, 0.3, [], 0.2, []],
  1214: [12, 14, 1.2, [], 1, []],
  1320: [13, 20, -1, [5], -1, [8]],
  132: [13, 2, -1, [5], -1, [8]],
  133: [13, 3, -1, [5], -1, [8]],
  134: [13, 4, -1, [5], -1, [8]],
  135: [13, 5, 0.3, [], 0.1, []],
  136: [13, 6, 0.4, [], 0.1, [15]],
  137: [13, 7, 1, [], 0.1, []],
  138: [13, 8, 0.6, [], 0.2, [17]],
  139: [13, 9, 0.3, [], 0.2, []],
  1310: [13, 10, 0.3, [], 0.2, []],
  1311: [13, 11, 0.3, [14], 0.1, []],
  1312: [13, 12, 0.3, [], 0.2, []],
  1313: [13, 13, -1, [], -1, []],
  1314: [13, 14, 1.2, [], 1, []],
  1420: [14, 20, 1, [], 1, []],
  142: [14, 2, 1, [], 1, []],
  143: [14, 3, 1, [], 1, []],
  144: [14, 4, 1, [], 1.3, []],
  145: [14, 5, 1, [], 1, [5]],
  146: [14, 6, 1.2, [], 1, []],
  147: [14, 7, 1.2, [], 1, []],
  148: [14, 8, 1.2, [], 1.5, []],
  149: [14, 9, 1.2, [], 1, []],
  1410: [14, 10, 1.2, [], 1, []],
  1411: [14, 11, 1.2, [], -1, []],
  1412: [14, 12, 1.2, [], 1, []],
  1413: [14, 13, 1.2, [], 1, []],
  1414: [14, 14, -1, [], -1, []]
}
